/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialClassStudentViewModel } from "../types/CourseFinancialClassStudentViewModel.ts";

export const courseFinancialClassStudentViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do vínculo entre o plano e a turma."),
  ),
  courseFinancialId: z.optional(
    z.number().int().describe("ID do plano financeiro."),
  ),
  classStudentId: z.optional(z.number().int().describe("ID da turma.")),
  classStudentName: z.string().describe("Descrição da turma.").nullish(),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do vínculo. Opcional.")
    .nullish(),
  userCreation: z
    .string()
    .describe("Usuário responsável pela criação. Opcional.")
    .nullish(),
}) as unknown as ToZod<CourseFinancialClassStudentViewModel>;
